import { createSelector } from '@reduxjs/toolkit';
import selfSelector from './self';

const reportSelector = createSelector(selfSelector, (domainsReport) => domainsReport.report);

export default reportSelector;
